import { motion } from "framer-motion";

import ecommerceImg from "./assets/ecommercee.webp";

const HeroSection = () => {
  return (
    <section className="w-full bg-[#FFF6DA] py-10 px-4 sm:px-6">
      <div className="w-full max-w-[1312px] flex flex-col lg:flex-row items-center justify-between gap-10">
        {/* LEFT CONTENT */}
        <motion.div
          className="w-full lg:w-[60%] mx-8"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <p className="text-[#212129] text-sm mb-3 uppercase font-semibold tracking-wider">
            E-Commerce
          </p>
          <h1 className="text-[#212129] text-[40px] md:text-[44px] leading-[52px] md:leading-[52px] font-extrabold mb-[24px]">
            Smarter Shopping <br className="hidden lg:block" />
            Personalized for You.
          </h1>
          <p className="text-[#212129] text-[16px] md:text-[16px] leading-[28px] md:leading-[24px] max-w-[600px]">
            Experience an AI-powered e-commerce platform that understands your
            taste, predicts your needs and delivers faster.
          </p>
        </motion.div>

        {/* RIGHT IMAGE */}
        <motion.div
          className="w-full lg:w-[50%] flex justify-center lg:justify-end md:ml-40"
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: true }}
        >
        <img
  src={ecommerceImg}
  alt="Ecommerce Illustration"
  className="w-[380px] sm:w-[460px] lg:w-full max-w-[750px] h-auto object-contain"
/>
        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection;
